import { PRODUCTS } from "@/data/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {PRODUCTS.map((p, i) => (
      <span key={p.id} className="flex items-center">
        <span className={`whitespace-nowrap px-8 font-display text-4xl font-black italic tracking-tight sm:text-6xl lg:text-7xl ${i % 2 ? "text-outline" : "text-white"}`}>
          {p.name}
        </span>
        <svg viewBox="0 0 40 20" className="h-6 w-12 shrink-0 sm:h-8 sm:w-16" aria-hidden>
          <ellipse cx="20" cy="10" rx="18" ry="6" fill="none" stroke="#8bd43f" strokeWidth="3" transform="rotate(-14 20 10)" />
        </svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="products-marquee" className="marquee-wrap grain relative overflow-hidden bg-[var(--ink)] py-10 sm:py-14">
    <div className="marquee-track flex w-max">
      <Row />
      <Row />
    </div>
  </section>
);
